<template>
<main class="content">
	<div class="row">
		<h1>
              Blocked timeslots
          </h1>
	</div>
	<div class="topBar">
		<div class="topBar--item_left">
			<div class="input_text">
				<v-select v-model="wallId" :searchable="false" placeholder="Click to select a wall" :options="walls"></v-select>
			</div>
			<button class="btn btn_blue u-mr1" @click="filter()">
                  Filter
              </button>
			<button v-if="query.wallId" class="btn btn_blue" @click="reset()">
                  X
              </button>
		</div>
		<div class="topBar--item_right">
			<router-link to="/blocked/add" class="btn btn_blue">
				Block new timeslots
			</router-link>
		</div>
	</div>
	<div class="table">
		<div class="table--row table--row_header">

			<div v-bind:class="getSortClasses('from')" style="max-width:168px" @click="sort('from')">
				<div class="table--col-title">
					From
					<div class="table--col-arrows">
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
					</div>
				</div>
			</div>
			<div v-bind:class="getSortClasses('to')" style="max-width:178px" @click="sort('to')">
				<div class="table--col-title">
					To
					<div class="table--col-arrows">
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
					</div>
				</div>
			</div>
			<div v-bind:class="getSortClasses('wall.name')" class="u-unclickable" style="max-width:189px" @click="sort('wall.name')">
				<div class="table--col-title">
					Wall
					<div class="table--col-arrows">
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
					</div>
				</div>
			</div>
			<div class="table--col" style="max-width:577px">
				<div class="table--col-title">
					Reason
				</div>
			</div>
			<div class="table--col" style="max-width:96px">
			</div>
		</div>
		<div class="table--row" v-for="item in blocked">
			<div class="table--col" style="max-width:168px">
				<strong>
                      {{item.fromDate | moment("tz", item.wall.city.timezone, "MM/DD/YY")}}
                  </strong>
				<span>
                      {{item.fromDate | moment("tz", item.wall.city.timezone, "hh:mma")}} - {{item.fromDate | moment("add", "15 minutes", "tz", item.wall.city.timezone, "hh:mma")}}
                  </span>
			</div>
			<div class="table--col" style="max-width:178px">
				<strong>
                      {{item.toDate | moment("tz", item.wall.city.timezone, "MM/DD/YY")}}
                  </strong>
				<span>
                      {{item.toDate | moment("tz", item.wall.city.timezone, "hh:mma")}} - {{item.toDate | moment("add", "15 minutes", "tz", item.wall.city.timezone, "hh:mma")}}
                  </span>
			</div>
			<div class="table--col" style="max-width:189px">
				<strong>
                      {{item.wall.name}}
                  </strong>
				<span>
                      {{item.wall.city.name}}
                  </span>
			</div>
			<div class="table--col" style="max-width:577px">
				<p>
					{{item.reason}}
				</p>
			</div>
			<div class="table--col" style="max-width:96px">
				<router-link :to="{ name: 'EditBlocked', params: { id: item.id }}" class="btn btn btn_blueLight">
					Edit
				</router-link>
			</div>
		</div>
	</div>
	<a class="btn btn_green u-fleft" @click="fetchResource()" v-if="nextPage">
            Load more
        </a>
	<loading :visible.sync="loadingVisible"></loading>
</main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import * as ListResource from '../../mixins/listResource.mixin';
import Loading from '../Loading.vue'
import vSelect from "vue-select"

var moment = require('moment');

export default {
	name: 'Blocked',
	components: {
		Loading,
		vSelect
	},
	mixins: [ListResource],
	data() {
		return {
			model: 'blocked',
			resource: 'schedule/blocked',
			blocked: [],
			query: this.$route.query,
			walls: [],
			wallId: '',
			sortOrder: 'desc',
			sortAttribute: 'from'
		}
	},
	created() {
		var self = this;
		HttpService.index('walls', {}, function(response, error) {
			self.walls = response.result.data;
			self.walls = self.walls.map(item => {
				return {
					value: item.id,
					label: item.name
				}
			});

			if (self.query.wallId) {
				self.wallId = self.walls.find(item => item.value == self.query.wallId);
			}
		});
	},
	methods: {
		filter() {
			if (this.wallId && this.wallId.value && this.wallId.value !== this.query.wallId) {
				window.open('#/blocked?wallId=' + this.wallId.value, '_blank');
			}
			return false;
		},
		reset() {
			this.query = {};
			this.wallId = null;
			this.fetchResource();
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Blocked.vue?3f46b0e2